import Styles from './styles.module.scss';

import type { NotificationModel } from '../../model/types/notification.model';

interface TitleProps {
	item: NotificationModel;
}

export const Title = ({ item }: TitleProps) => {
	return (
		<div className={Styles.titleContainer}>
			<p>{item.title}</p>
			<span>{item.body}</span>
		</div>
	);
};
